// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

function Product(props) {
  const to = `/products/${props.id}`;
  let percentOff;
  let offPrice: any = `${props.price}$`;

  if (props.percentOff && props.percentOff > 0) {
    percentOff = (
      <div
        className="badge bg-dim py-2 text-white position-absolute"
        style={{ top: '0.5rem', right: '0.5rem' }}
      >
        {props.percentOff}% OFF
      </div>
    );

    offPrice = (
      <>
        <del>{props.price}$</del> {props.price - (props.percentOff * props.price) / 100}$
      </>
    );
  }

  return (
    <div className="col">
      <div className="card shadow-sm">
        <Link to={to}>
          {percentOff}
          <img className="card-img-top bg-dark cover" height="200" alt="" src={props.image} />
        </Link>
        <div className="card-body">
          <h5 className="card-title text-center text-dark text-truncate">{props.name}</h5>
          <p className="card-text text-center text-muted mb-0">{offPrice}</p>
          <div className="d-grid d-block">
            <Link to={to} className="btn btn-outline-dark mt-3">
              Detail
            </Link>
            {/* <button className="btn btn-outline-dark mt-3">
              <FontAwesomeIcon icon={['fas', 'cart-plus']} /> Add to cart
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;
